export enum CellEditInputType {
    Calendar,
    Checkbox,
    Dropdown,
    Multiselect,
    Number,
    Text, // Default
    Textarea
}
